export default "__VITE_ASSET__6a182d75__"